import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin({
  name: "ckweb:user",
  enforce: "pre",
  dependsOn: ["ckweb:auth", "ckweb:dev-console"],
  async setup($nuxt) {
    const { createCrossAppRedirectPath } = useAuthQueryParams();
    const { authStore } = useAuthApi();

    $nuxt.hook("ckauth:user-load-failed", () => {
      devConsole.log("🔔  ckauth:user-load-failed hook triggered");
      if (authStore.isAuthed) {
        devConsole.info(" 🔀  Cross App Redirect: scenarios E1 to E4 only self-service handles error cases");
        navigateTo(
          createCrossAppRedirectPath("sureKleanzSetup", {
            error: "auth.redirectReasonNoKLEANZUser",
          }),
        );
      }
    });

    devConsole.info("🛠️ ckClient: user hooked  🚀🚀🚀🚀🚀");
  },
});
